<template>
  <div class="product_tab_1 outer_tab">
    <!--收起内容-->
    <div class="pulldownbox info-container" v-show="!showQueryFilter">
      <i class="el-icon-info"></i>
      <span>查询条件</span>
      <span class="pulldownbtn" @click="pulldown"
        >展开<i class="el-icon-arrow-down"></i
      ></span>
    </div>
    <!--展开内容-->
    <div
      style="width: 100%"
      class="expandbox info-container"
      v-show="showQueryFilter"
    >
      <el-form
        class="product_filter_form"
        :model="filterForm"
        inline
        ref="filterForm"
        size="small"
        label-width="100px"
      >
        <el-form-item label="选择区域:" prop="qhdmValue">
          <!--县乡村 联动-->
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.qhdmValue"
            :options="areaOptions"
            :props="areaProps"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="主体类型:" prop="enterpriseTypeNumber">
          <el-select
            v-model="filterForm.enterpriseTypeNumber"
            placeholder="请选择主体类型"
          >
            <el-option
              v-for="item in industryOptions"
              :key="item.dicNumber"
              :label="item.dicName"
              :value="item.dicNumber"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营类型:" prop="industryDicNumber">
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.industryDicNumber"
            :options="industryList"
            :props="industryProps"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="是否首次提交:"
          prop="isFirstSubmit"
          style="width: 23%"
        >
          <el-select class="textInput" v-model="filterForm.isFirstSubmit">
            <el-option
              v-for="item in submitOptions"
              :key="item.number"
              :label="item.label"
              :value="item.number"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item label="主体名称:" prop="enterpriseName">
          <el-input
            class="textInput"
            v-model="filterForm.enterpriseName"
            placeholder="请输入主体名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="contacts">
          <el-input
            class="textInput"
            v-model="filterForm.contacts"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="成立日期:" prop="submitDate" class="small-input">
          <el-date-picker
            v-model="filterForm.submitDate"
            style="width: 250px"
            type="daterange"
            value-format="timestamp"
            unlink-panels
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-row style="text-align: center; margin: 5px 0">
        <el-button @click="queryBtnClick" type="primary" size="small"
          >查询</el-button
        >
        <el-button @click="resetFilter" type="primary" plain size="small"
          >重置</el-button
        >
        <span class="pullupbtn" @click="pullup"
          >收起<i class="el-icon-arrow-up"></i
        ></span>
      </el-row>
    </div>
    <div
      style="height: 100%; position: relative"
      class="tablebox info-container"
    >
      <!--总计内容-->
      <el-row class="count_content">
        <i class="el-icon-success icon-table-summary"></i>
        <span
          >共查询到
          <span class="count_number">{{ totalItems }}</span> 条数据</span
        >
      </el-row>
      <!--table-->
      <div style="height: 100%; position: relative">
        <el-table
          class="product_tab_1_table"
          :data="tableData"
          ref="dataTable"
          @current-change="handleCurrentChange"
          height="100%"
          highlight-current-row
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="qhmc"
            label="区划"
            min-width="30"
            :formatter="formatterFn"
          ></el-table-column
          ><el-table-column
            prop="enterpriseName"
            label="主体名称"
            min-width="30"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="enterpriseTypeName"
            label="主体类型"
            min-width="30"
          >
          </el-table-column>
          <el-table-column
            prop="industryDicName"
            label="经营类型"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="contacts"
            label="法人姓名"
            min-width="25"
            :formatter="formatterFn"
          ></el-table-column>
          <el-table-column
            prop="createDate"
            label="成立时间"
            min-width="25"
            :formatter="formatterDate"
          ></el-table-column>
          <el-table-column
            prop="isFirstSubmit"
            label="是否首次提交"
            min-width="25"
            :formatter="formatterState"
          ></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" content="详情" placement="top">
                <i
                  class="table-icon el-icon-document"
                  @click="searchDialog(scope.row)"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页工具-->
      <el-row class="page-row">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          :total="totalItems"
        >
        </el-pagination>
      </el-row>
    </div>
    <detail-dialog
      :ifAudit="true"
      :ifRejected="false"
      @tableRefresh="priseList"
      ref="show_operator_dialog"
    ></detail-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import detailDialog from "./detailDialog";
import API from "@/api/serviceOrgManagement/api_userManagement";
export default {
  components: {
    detailDialog,
  },
  name: "contract-list",
  data() {
    return {
      //区域参数
      areaOptions: [],
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      industryProps: {
        label: "name",
        value: "number",
      },
      filterForm: {
        qhdmValue: [Cookies.get("curAreaCode")], // 区域
        enterpriseName: "", // 主体名称
        enterpriseTypeNumber: "", // 主体类型
        industryDicNumber: "", // 所属行业名称
        contacts: "", // 法人姓名
        isFirstSubmit: "", // 是否首次提交
        submitDate: "", // 日期
      },
      submitOptions: [
        { label: "是", number: 1 },
        { label: "否", number: 0 },
      ],
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      showQueryFilter: true /*是否显示搜索条件*/,
      currentRow: "" /*当前选中的table行*/,
      tableData: [] /*table数据源*/,
      params: {}, // 查询参数
      industryOptions: [], //主体类型列表
      industryList: [], //行业列表
    };
  },
  created() {
    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("firstLoadAreaOption", this.getNextXzqData); //
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$off("firstLoadAreaOption", this.getNextXzqData); //
  },
  mounted() {
    this.init();
  },
  methods: {
    formatterFn(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return cellValue;
    },
    formatterDate(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Number(cellValue),'date');
    },
    formatterState(row, column, cellValue, index) {
      if (cellValue === 1) {
        return "是";
      } else if (cellValue === 0) {
        return "否";
      } else {
        return "--";
      }
    },
    /*页面初始化*/
    init() {
      this.getParams();
      this.managementTypeList();
      this.priseList();
      this.getNextXzqData();
      this.commonList();
    },
    //获取区域数据
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      }
    },
    // 主体类型列表接口
    async commonList() {
      let { code, data } = await API.commonList({ code: 99 });
      if (code === 0) {
        if (data && data.list && data.list.length) {
          this.industryOptions = data.list;
        }
      }
    },
    //  参数设置
    getParams() {
      let form = this.filterForm;
      this.params = {
        // 参数
        qhdm: form.qhdmValue[form.qhdmValue.length - 1],
        page: this.currentPage, // 页数
        enterpriseName: form.enterpriseName, // 主体名称
        enterpriseTypeNumber: form.enterpriseTypeNumber, // 主体类型
        industryDicNumber:
          form.industryDicNumber[form.industryDicNumber.length - 1], // 所属行业名称
        contacts: form.contacts, // 法人姓名
        status: 4, // 审核状态
        isFirstSubmit: form.isFirstSubmit, // 是否首次提交
        startTime: form.submitDate[0] ? form.submitDate[0] : "", //开始时间
        endTime: form.submitDate[1]
          ? form.submitDate[1] + (1000 * 60 * 60 * 24 - 1000)
          : "", //结束时间
      };
    },
    //企业信息列表接口
    async priseList() {
      const { code, data } = await API.priseList(this.params);
      if (code === 0) {
        this.totalItems = data.count;
        this.tableData = data.unauditeList;
      }
    },
    //查询所属行业接口
    async managementTypeList() {
      let { code, list } = await API.managementTypeList();
      if (code === 0) {
        this.industryList = list;
      }
    },
    //设备详情
    searchDialog(row) {
      this.$refs.show_operator_dialog.dialogOpen(row);
    },
    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.params.page = val;
      this.priseList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.getParams();
      this.priseList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.filterForm.page = this.currentPage = 1; // 页数
      this.filterForm.enterpriseName = ""; // 主体名称
      this.filterForm.enterpriseTypeNumber = ""; // 主体类型
      this.filterForm.industryDicNumber = ""; // 所属行业名称
      this.filterForm.contacts = ""; // 法人姓名
      this.filterForm.isFirstSubmit = ""; // 是否首次提交
      this.filterForm.qhdmValue = [Cookies.get("curAreaCode")]; // 区域
      this.filterForm.submitDate = ""; // 日期
    },
    /*table选中行回调方法*/
    handleCurrentChange(val) {
      this.currentRow = val;
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
  },
};
</script>
<style lang="less">
el-dialog__header {
  background: red;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/studio/subject/libraryListReviewed/auditList.vue